import { entrypoint, viewOf } from "../../client/index.ts";
import "./fragment.ts";

const publico = viewOf("publico");

export const entrypoints = [
  entrypoint({
    id: "convite",
    path: "/convite",
    public: true,
    data: () => publico(),
    view: () => import("./invite.tsx"),
  }),
  entrypoint({
    id: "entrar",
    path: "/entrar",
    public: true,
    data: () => publico(),
    view: () => import("./sign-in.tsx"),
  }),
];
